import { z } from "zod";

export const REPLACE_SIGNED_TERM_MESSAGES = {
  FILE_REQUIRED: "Selecione o novo termo assinado.",
  REASON_REQUIRED: "Informe o motivo da substituição.",
} as const;

export const replaceSignedTermSchema = z.object({
  file: z.custom<File>((value) => value instanceof File, {
    message: REPLACE_SIGNED_TERM_MESSAGES.FILE_REQUIRED,
  }),
  comment: z.string().trim().min(1, REPLACE_SIGNED_TERM_MESSAGES.REASON_REQUIRED),
});

export type ReplaceSignedTermFormValues = z.infer<typeof replaceSignedTermSchema>;
